export default {
  module_title: '机器人平台',
  messages: {
    license_fail_message: '获取License信息失败',
    org_fail_message: '获取组织列表失败',
    product_fail_message: '获取用户产品列表失败',
    role_user_cannot_delete_message: '当前角色已分配用户不可以删除。可取消当前角色的分配，然后删除角色',
    org_cannot_empty_msg: '组织名称不能为空',
    org_exist_msg: '组织名称已经存在',
    upper_org_cannot_be_empty: '上级组织不能为空',
    status_cannote_be_empty: '状态不能为空',
    role_empty_message: '角色名不能为空',
    source_empty_message: '数据来源不能为空',
    check_delete_user: '角色{user}已存在',
    no_product_msg: '该组织下暂未分配产品',
    no_selected_org: '尚未选择组织',
  },
  general: {
    place_holder: '输入关键字搜索',
    hide: '隐藏',
    system_name_default: 'Bot factory',
    enter: '进入',
    platform_name: '机器人平台',
    range: '区间',
    confirm: '确认',
    name: '名称',
    image: '图片',
    icon: '图标',
    clear_all: '清除全部',
    reset_to_default: '还原预设',
    pink_all: '选择全部',
    view: '查看',
    custom_column: '自定义栏位',
    default_column: '预设栏位',
    enable: '启用',
    disable: '停用',
    setting: '设置',
    language: '语言',
    zh_tw: '繁體中文',
    zh_cn: '简体中文',
    us_en: 'English',
    delete_success: '删除成功',
    robot_list: '机器人列表',
    im: 'IM',
    no_data: '暂无数据',
    no_search_data: '暂无查询结果',
    no_option: '无选项',
    no_filterable_option: '无筛选结果',
    clearchecked: '删除所选项',
    reset: '重置',
    chat_test: '功能检测',
    custom: '自定义',
    yes: '是',
    no: '否',
    empty: '无',
    operation: '操作',
    search: '查询',
    all: '全部',
    add: '新增',
    actions: '操作',
    status: '状态',
    edit: '编辑',
    delete: '删除',
    remove: '移除',
    question: '问题',
    answer: '答案',
    ext_answer: '答案扩展',
    ok: '确认',
    cancel: '取消',
    canceled: '已取消',
    confirm_edit: '确认修改',
    already_cancel: '已取消',
    loading: '页面载入中',
    table_loading: '表格载入中...',
    error_code: '错误代码',
    error: '错误',
    upload: '上传',
    browse: '浏览',
    copy: '复制',
    save: '保存',
    saving: '保存中',
    default: '默认',
    indicate: '指定',
    force_cancel: '强制取消',
    import: '导入',
    export: '导出',
    success: '成功',
    fail: '失败',
    description: '提示',
    file: '档案',
    finish: '完成',
    folder: '目录',
    search_placeholder: '请输入搜索内容',
    close: '关闭',
    test: '测试',
    modify: '修改',
    save_change: '储存变更',
    go_back: '返回',
    please_choose: '请选择',
    intent: '意图',
    select_all: '全选',
    download: '下载',
    batch_import: '批量导入',
    unit1: '条',
    unit2: '个',
    start_date: '开始时间',
    end_date: '结束时间',
    batch_upload: {
      only_xlsx_xls: '仅支持xlsx，xls格式文件',
      file_invalid: '文件验证错误',
      upload_file: '上传文件',
      choose_file: '选择文件',
      download_template: '下载模板',
      upload_mode: '上传模式',
      add_data: '新增数据',
      add_data_desc: '只新增没有重复且有效的数据',
      replace_all: '全量替换',
      replace_all_desc: '全量替换会先删除当前所有数据，再上传文件的数据。请谨慎操作，注意数据备份',
      tip: '注意事项',
      tips: '1. 支持xlsx的文件格式进行上传</br>2. 请参考模板中的文档说明，按照照格式填写 </br>3. 全量替换将替换掉所有数据且无法回复，建议先备份数据',
      empty_file: '上传的内容为空, 请重新选择文件!',
      oversize_file: '上传的行数不可超过%1行',
      confirm_upload: '确认导入',
    },
    export_all: {
      title: '数据导出',
      export_current: '导出当前数据',
      upload_history: '导入历史',
      history_count: '只保留近%d次导入数据',
      file_name: '文档名称',
      upload_time: '上传时间',
      action: '操作',
      download: '下载',
      download_error: '错误报告',
      status: '状态',
      upload_success: '导入成功',
      upload_fail: '导入失败',
      file_replaced: '文件被覆盖',
      no_sheet_file: '上传文件中找不到目标页',
      invalid_templ_version: '导入模板版本不适配',
      part_success: '部分导入成功',
      upload_type: '上传模式',
      add_mode: '增量',
      replace_mode: '全量',
    },
    log_off: '注销',
    load_more: '加载更多',
    note: '注意',
    detail: '详情',
    license_expired: '许可证已过期,请联系管理员',
    edit_success: '操作成功',
    serial: '序号',
    pending: '加载中...',
    normal: '正常',
    abnormal: '异常',
    total: '共{total}条',
    uploading: '文件上传中...',
    dataLoading: '数据加载中...',
    switch: '开关',
    ok_modify: '确定修改',
    ok_add: '确定新增',
    tempLoading: '模版获取中...',
    line_wrap: '强制换行',
    on: '开',
    off: '关',
    load_temp: '载入模版',
    batch_delete: '批量删除',
    reload: '刷新',
    open_filter: '高级',
    close_filter: '收起',
    copied: '复制成功',
    license_probation_expired: '已过试用期，请联系管理员申请许可证',
  },
  management: {
    role_add_success: '角色新增成功',
    role_add_fail: '角色新增失败',
    role_update_success: '角色更新成功',
    role_update_fail: '角色更新失败',
    role_delete_success: '角色删除成功',
    role_delete_fail: '角色删除失败',
    user_has_no_role: '该用户尚未分配角色',
    no_active_org: '当前没有可选择的启用组织',
    user_amount: '用户数量',
    product: '产品',
    add_position: '新增角色',
    role_manage: '角色权限管理',
    basic_info: '基本信息',
    admin_account: '系统管理员账号',
    position_edit: '编辑角色',
    position_add: '添加角色',
    position_name: '角色名称',
    please_enter_position_name: '请输入角色名称',
    data_auth: '数据权限',
    data_source: '数据来源',
    please_choose_data_source: '请选择数据来源',
    please_choose_data_source_sub_type: '请选择数据来源子类型',
    operation_right: '操作权限',
    ccbot_auth_operate: '外呼平台权限配置',
    to_ccbot_auth_operate: '进入外呼平台权限配置',
    no_interrupt_tip: '进入后不会影响当前其他平台的配置操作',
    all_access_user: '该用户可以使用该产品的全部功能',
    add_confirm: '确认新增',
    basic_info_setting: '基本信息设置',
    update_confirm: '确定编辑',
    role_assign: '分配角色',
    enable: '启用',
    enabled: '已启用',
    disable: '禁用',
    disabled: '已禁用',
    encrypt_title: '机器人导出加密设置',
    encrypt_tips: '请为此文件设置密码',
    file_pwd: '文件密码',
    file_pwd_confirm: '确认密码',
    file_pwd_placeholder: '请输入文件密码',
    file_pwd_confirm_placeholder: '确认密码',
    confirm_export: '确定并导出',
    import_encrypt_title: '机器人导入',
    import_encrypt_tips: '此文件已加密，请输入文件密码',
    import_pwd_tips: '若忘记密码请联系管理员或重新导出文件',
    confirm_import: '确定并导入',
    pwd_empty: '密码和确认密码都不能为空',
    pwd_error: '密码不一致',
    pwd_reg_tips: '请输入6-16位的数字或者英文',
    exporting_msg: '正在导出中，请稍等~',
    import_err_msg: '导入失败！{message}',
    import_moudule_err_msg: '因 {messaeg} 模块导入失败',
    robot_group_placeholder: '搜索机器人群组',
    robot_list_placeholder: '搜索机器人',
    import_robot: '导入机器人',
    total_robot_message: 'hi {name}, 您已创建{num}个机器人',
    open: '已启用',
    un_use: '未启用',
    add_enterprise_success: '企业添加成功',
    add_enterprise_fail: '企业添加失败',
    edit_enterprise_success: '企业修改成功',
    enterprise_setting: '企业设置',
    organization_list: '企业组织',
    enterprise_status: '企业状态',
    enterprise_search_text: '输入企业名称搜索',
    user_management: '用户管理',
    role_list: '角色权限',
    icon_setting: '图标设置',
    enterprise_icon_setting: '企业图标设置',
    enterprise_lu_icon: '企业左上图标',
    enterprise_lu_icon_info: '支持格式 svg, png，文件大小限制为 1mb，建议图片大小22px*22px',
    browser_page_icon: '浏览器页签',
    browser_page_icon_info: '支持格式 png ，文件大小限制为1mb，建议宽高比例20px*20px',
    table_robot_list: '机器人列表',
    table_group_name: '群组名称',
    robot_template: '机器人模板',
    return_to_robot_list: '返回机器人列表',
    import_robot_running: '机器人正在导入中...',
    import_robot_time: '预计需要10分钟',
    create_from_template: '从模板创建',
    list_robot_name: '机器人',
    operate: '操作',
    upload_wating: '当前导入任务还未完成，请等待任务完成后再操作',
    upload_success: '导入成功',
    export_wating: '当前有机器人正在导出请稍等',
    faq_count: '标准问答：',
    te_count: '任务场景：',
    system_setting: '系统设置',
    gatway_setting: '落地网关设置',
    inbound_and_scenario_setting: '呼入路由及场景配置',

    icon_management: '图标管理',
    system_icon_setting: '系统图标设置',
    system_lu_icon: '系统左上图标',
    login_icon: '登录画面图标',
    login_icon_info: '支持格式 svg,png ，文件大小限制为1mb，建议文件大小 320px*45px',
    group_name: '群组名称',
    enterprise_list: '企业管理',
    admin_list: '管理员设置',
    enterprise: '企业',
    create_enterprise: '创建企业',
    delete_enterprise: '删除企业',
    edit_enterprise: '编辑企业',
    create_time: '创建时间',

    enterprise_name: '企业名称',
    enterprise_description: '企业描述',
    module_list: '功能列表',
    product_list: '该企业可以使用以下产品',

    system_admin_list: '系统管理人员',
    system_admin_desc: '创建企业时，必须指定一位企业管理人员',

    robot_group: '机器人群组',
    robots: '机器人',
    robot_list: '机器人列表',

    create_robot: '创建新机器人',
    delete_robot: '删除机器人',
    edit_robot: '编辑机器人',
    group_manage: '机器人群组管理',

    robot_name: '机器人名字',
    description: '描述',
    no_description: '无描述信息',
    input_placeholder: '输入文字',
    length_50_placeholder: '字数限制50内',
    chat_language: '对话语言',

    create_group: '创建群组',
    edit_group: '修改群组',
    delete_group: '删除群组',
    add_robot: '加入机器人',
    input_personal_pass: '输入个人密码',
    reason_description: '原因描述',

    user_preference: '个人资料',
    edit_data: '修改资料',
    edit_user_preference: '修改个人资料',

    enterprise_privilege_manage: '企业权限管理',
    add_account: '新增帐号',
    edit_account: '编辑人员',
    add_role: '新增权限',
    privilege_setting: '权限设定',
    role_name_placeholder: '输入角色名称',
    normal_user: '一般用户',
    enterprise_admin: '企业管理员',
    system_admin: '系统管理员',
    unknown: '未知',

    user_name: 'ID',
    user_type: '帐号类型',
    user_display_name: '姓名',
    phone: '联络电话',
    email: 'Email',
    next_step: '下一步',
    last_step: '上一步',
    password: '密码',
    set_password: '设置密码',
    check_password: '确认密码',
    modify_password: '修改密码',
    set_passowrd_placeholder: '请输入密码',
    set_right_origin_pwd: '请输入正确的旧密码',
    check_password_placeholder: '再输入一次密码',
    assign_robot: '指定机器人',
    privilege_is: '权限为',

    manager_password: '管理员密码',
    orig_password: '原密码',
    new_password: '新密码',
    check_new_password: '确认新密码',
    password_format: '介于6~16字的英文字母、数字或符号，须包含大小写英文字母与数字',
    username_format: '介于4~64字的英文字母、数字或 @._-',
    err_empty_username: 'ID 不可为空',
    err_existed_username: 'ID 已存在',
    err_username_length: 'ID 长度需介于4~64字之间',
    err_invalid_username: '不合法的 ID 格式',
    err_empty_email: 'Email 不可为空',
    err_invalid_email: '不合法的 Email 格式',
    err_invalid_phone: '不合法的电话格式',
    err_empty_display_name: '姓名不可为空',
    err_display_name_length: '姓名长度需介于2~50字之间',
    err_password_length: '密码长度需介于6~16字之间',
    err_password_invalid: '不合法的密码格式',
    err_password: '密码错误',
    err_origin_password: '原密码错误',
    err_manager_password: '管理员密码错误',
    err_manager_empty_password: '管理员密码不可为空',
    err_origin_empty_password: '原密码不可为空',
    err_invalid_check_password: '两次密码输入不同',
    update_password_success: '更新密码成功',
    add_user_success: '新增使用者成功',
    err_update_password_fail: '更新密码失败',
    err_role_duplicate: '角色名称已存在',
    err_robot_name_empty: '机器人名称不可为空',
    err_robot_duplicate: '机器人名称已存在',
    err_enterprise_name_empty: '企业名称长度需介于1~50字之间',
    err_enterprise_duplicate: '企业名称已存在',

    err_group_name_empty: '群组名称不可为空',
    err_group_duplicate: '群组名称已存在',
    err_pick_no_modules: '功能列表至少需勾选一个',
    err_reason_empty: '删除原因不可为空',
    err_enterprise_admin_duplicate: '企业管理员帐号名已存在',
    err_enterprise_email_duplicate: '企业管理员信箱已存在',
    err_unkown: '发生未知错误',
    err_add_robot_fail: '新增机器人失败',
    err_add_robot_fail_license: '授权机器人数量已用完',
    go_back: '返回',
    audit: {
      system: '系统操作记录',
      enterprise: '企业操作记录',
      robot: '机器人操作记录',
      filter_time: '发生时间',
      filter_robot: '机器人',
      filter_module: '操作模块和类型',
      filter_userid: '用户ID',
      filter_enterprise: '企业',
      total: '共 {num} 条',
    },
    privilege: {
      statistic_dash: {
        view: '统计概览',
      },
      ssm: {
        view: '常用标准问答查看',
        edit: '常用标准问答编辑',
        export: '常用标准问答导出',
        import: '常用标准问答导入',
      },
      qa_label: {
        view: '标签管理查看',
        edit: '标签管理编辑',
      },
      ssm3: {
        view: '查看标准问答',
        import: '导入数据',
        export: '导出数据',
        'create-sq': '手动添加标准问答',
        'del-sq': '删除标准问题',
        'edit-sq': '编辑标准问题',
        'edit-answer': '编辑回答',
        'edit-lq': '编辑语料',
        train: '训练数据',
        test: '测试及报告',
        publish: '发布上线',
        'edit-label': '管理标签',
      },
      qa_records: {
        view: '审核变更',
      },
      task_engine: {
        edit: '任务引擎编辑',
      },
      wordbank: {
        view: '查看',
        edit: '编辑',
        create: '新增',
        delete: '删除',
        import: '导入',
        export: '导出',
        upload_file_size_error: '文件大小超过限制',
      },
      statistic_analysis: {
        view: '统计分析查看',
        export: '统计分析导出',
      },
      statistic_daily: {
        view: '日志管理查看',
        export: '日志管理导出',
      },
      statistic_audit: {
        view: '操作记录查看',
        export: '操作记录导出',
      },
      robot_profile: {
        view: '机器人形象查看',
        edit: '机器人形象编辑',
      },
      robot_chat_skill: {
        view: '话术设置查看',
        edit: '话术设置编辑',
      },
      robot_function: {
        view: '技能设置查看',
        edit: '技能设置编辑',
      },
      robot_command: {
        view: '指令设置查看',
        edit: '指令设置编辑',
      },
      intent_manage: {
        view: '意图管理查看',
        edit: '意图管理编辑',
        export: '意图管理导出',
        import: '意图管理导入',
      },
      integration: {
        view: '接入部署查看',
        edit: '接入部署编辑',
      },
      robot_config: {
        view: '机器人设定查看',
        edit: '机器人设定变更',
      },
      ner_factory: {
        view: '查看',
        edit: '编辑',
        create: '新增',
        delete: '删除',
        import: '导入',
        export: '导出',
      },
      domain_kg: {
        view: '知识推理引擎查看',
        edit: '知识推理引擎编辑',
        delete: '知识推理引擎删除',
        import: '知识推理引擎导入',
      },
      health_check: {
        view: '查看健康检查',
        edit: '编辑健康检查',
      },
    },
    org: {
      all_org: '全部组织',
      businessOrgan_list: '企业组织',
      treeTitle: '组织关系',
      rightHeader: '组织列表 - ',
      rightStatus: '组织状态',
      placeholder: '输入文字，回车搜索',
      addOrg: '新建组织',
      tableName: '组织名称',
      tableUp: '上级组织',
      tablePro: '可用产品',
      tableStatus: '状态',
      tableOr: '操作',
      editOrg: '编辑组织',
      confirm: '确定创建',
      editSure: '确定修改',
      editStatus: '状态修改成功',
      popup: {
        title: '基本信息',
        orgName: '组织名称',
        orgUp: '上级组织',
        status: '状态',
        product: '该组织可以使用以下产品',
        placeholder: '输入组织名称',
        addSuccess: '新建组织成功',
        upSuccess: '修改组织成功',
      },
    },
    userManage: {
      userManage_list: '用户管理',
      rightHeader: '用户账号管理',
      rightOrg: '所属组织',
      rightStatus: '用户状态',
      addAccount: '新增账号',
      name: ' 用户名',
      accountType: '账号类型',
      lastName: '姓名',
      phone: '联系电话',
      Email: 'Email',
      ownerOrg: '所属组织',
      siblingOrg: '关联组织',
      status: '状态',
      operate: ' 操作',
      placeholder: '输入文字，回车搜索',
      userType: '开始创建',
      addSuccess: '新建用户成功',
      upSuccess: '修改用户成功',
      popup: {
        adduser: '新增账号',
        edituser: '编辑账号',
        confirm: '确定创建',
        editSure: '确定修改',
        account: '账号信息',
        username: '用户名',
        name: '姓名',
        phone: '联络电话',
        Email: 'Email',
        password: '设置密码',
        updatePw: '新密码',
        updateSurePw: '确认新密码',
        surePassword: '确认密码',
        adminPw: '管理员密码',
        status: '用户状态',
        ownerOrg: '所属组织',
        siblingOrg: '关联组织',
        guest: '一般用户',
        admin: '企业管理员',
        placeholder: '请选择',
        placeholderUser: '请输入用户名',
        placeholderName: '请输入姓名',
        placeholderPhone: '请输入联络电话',
        placeholderEmail: '请输入联系邮箱地址',
        placeholderAdmin: '请输入管理员密码',
        placeholderPs: '请输入要设定的密码',
        placeholderSureMsg: '请再次输入密码',
        password_format: '介于6~16字的英文字母、数字或符号，须包含大小写英文字母与数字',
        username_format: '介于4~50字的英文字母、数字或 @._-',
        sectionTitle: '角色分配',
        robot: '指定机器人',
        roles: '角色',
        addButton: '新增指定机器人',
        addRoleButton: '新增指定角色',
        noRobot: '暂不支持角色分配',
      },
    },
    model_management: '模型管理',
  },
  privileges: {
    role: '角色',
    user: '用户',
    password: '密码',
    role_name: '角色名',
    user_name: '用户名',
    privileges: '权限',
    user_count: '用户数',
    function_priv: '功能权限',

    placeholder_user_name: '请输入用户名',
    placeholder_password: '请输入密码',
    placeholder_modify_password: '若要变更则输入密码',
    placeholder_input_role_name: '请输入角色名',

    enterprise_admin: '企业管理员',

    no_roles: '无角色存在',
    no_users: '无用户存在',
    all_active: '开启全部',
    all_deactive: '关闭全部',

    check_delete: '确认要删除角色：{role}',
    check_delete_user: '确认要删除用户：{user}',
    check_cancel_user: '确认要注销用户：{user}',
    delete_success: '删除成功',
    err_need_create_role: '请先新增角色',
    err_role_empty: '角色不可为空',

    actions: {
      edit: '编辑',
      view: '查看',
      create: '新增',
      delete: '删除',
      export: '导出',
      import: '导入',
      login: '登录',
      logout: '登出',
      publish: '发布',
      active: '启动',
      deactive: '关闭',
      train: '训练',
      revert: '回退',
      sync: '同步',
      mark: '标注',
      ignore: '忽略',
      cluster: '辅助分类',
      sq_add: '添加标准问题',
      sq_edit: '修改标准问题',
      sq_delete: '删除标准问题',
      sq_import: '上传标准问题',
      sq_publish: '标准问题发布',
      lq_add: '新增语料',
      lq_edit: '保存/修改扩写',
      lq_delete: '删除语料',
      lq_import: '上传语料',
      ans_add: '新增回答',
      ans_edit: '编辑回答',
      test_import: '上传测试题',
    },

    modules: {
      statistic_dash: '统计概览',
      statistic_analysis: '统计分析',
      statistic_daily: '日志管理',
      statistic_audit: '操作记录',
      statistic_heatlh_check: '健康检查',

      ssm: '常用标准问题',
      qa_label: '标签管理',
      ssm3: '常用标准问题',
      qa_records: '审核变更',
      domain_kg: '知识推理引擎',
      health_check: '健康检查',
      ccs_config: '中控系統',

      qalist: '问答库',
      qatest: '对话测试',
      qa_chat_skill: '话术设置',
      qa_rule: '规则管理',

      robot_profile: '机器人形象',
      robot_chat_skill: '话术设置',
      robot_function: '技能设置',
      robot_command: '指令设置',
      robot_config: '机器人设定',
      wordbank: '词库',
      task_engine: '任务引擎',

      management: '权限管理',
      intent_manage: '意图引擎',
      integration: '接入部署',
      chat_test_tools: '对话测试',
      material: '素材库',
    },
    tools: {
      encrypt: {
        title: '加密工具',
        button: '加密',
        copy_button: '复制',
        placeholder: {
          encrypt_from: '输入欲加密的文字',
          encrypt_to: '加密结果会显示在这里',
        },
        fail: '加密失败',
        copied: '已复制加密文字',
      },
    },
  },
  pages: {
    null: '',
    manage_admin: {
      module_name: '系统管理人员',
    },
    manage_enterprise: {
      module_name: '企业列表',
    },
    manage_user: {
      module_name: '企业用户管理',
    },
    manage_robot: {
      module_name: '机器人列表',
    },
    status: {
      module_name: '数据总览',
      statistic_dash: '统计概览',
    },
    ccs: {
      module_name: '对话管理',
    },
    ssm: {
      module_name: '问答管理',
      ssm: '常用标准问题',
      qa_label: '标签管理',
      history: '变更记录',
    },
    chat_tools: {
      module_name: '工具',
      chat: '对话测试工具',
    },
    privileges: {
      module_name: '权限管理',
      role_manage: '角色管理',
      user_manage: '用户管理',
      other_tools: '其他工具',
    },
    robot_setting: {
      module_name: '机器人设置',
      robot_profile: '机器人形象',
      robot_function: '技能设置',
      robot_chat_skill: '话术设置',
      robot_command: '指令设置',
      integration: '接入部署',
      robot_config: '系统功能配置',
      message: '如果您设置了多个回答，你的机器人会随机选择一个回答进行回复。\n' +
        '如果您对回答设定了维度，则该回答只能在指定维度上应用；无设定则为全维度范围应用。',
      check_other_question: '查看其他问法',
      add_answer: '增加回答',
      edit_answer: '回答编辑',
      edit_question: '问法编辑',
      other_question: '你希望这个问题有什么其他的问法？',
      add_question: '新增问法',
      cancel: '取消',
      add: '添加',
      no_question: '暂无其他问法',
      save: '确定保存',
      confirm_modification: '确定修改',
      quit_modification: '放弃修改',
      err_empty_robot: '回答内容不能为空',
      demo_question: '示例问法',
      hotspot_issues: '热点问题配置',
    },
    wordbank: {
      module_name: '词库',
      wordbank_list: '词库关系',
      wordbank_upload: '词库导入',
    },
    faq: {
      module_name: '问答管理',
      qalist: '问答库',
      qa_greeting: '寒暄库',
      qatest: '对话测试',
      qa_chat_skill: '话术设置',
      qa_label: '标签管理',
      qa_rule: '规则管理',
      qa_learning: '自学习',
    },
    statistics: {
      module_name: '对话数据',
      statistic_analysis: '统计分析',
      statistic_daily: '日志管理',
      statistic_audit: '操作记录',
      statistic_learning: '负反馈',
      statistic_session: '会话日志',
      statistic_heatlh_check: '健康检查',
    },
    task_engine: {
      module_name: '任务引擎',
      task_engine_scenario: '场景列表',
      task_engine_scenario_v2: '场景列表',
      task_engine_scenario_v3: 'TDE场景列表',
      task_engine_upload: '上传转换数据',
    },
    knowledge_graph: {
      module_name: '知识推理引擎',
      property_manage: '属性管理',
      relation_manage: '实体管理',
      material_manage: '变更审核',
      test_report: '测试报告',
      data_manage: '数据管理',
    },
    intent_engine: {
      module_name: '意图引擎',
      intent_manage: '意图管理',
      intent_manage_old: '旧意图管理',
      intent_test: '意图测试',
    },
    ner: {
      module_name: '自定义解析器',
      ner_extractor: '抽取器',
      ner_wordbank_upload: '词库导入',
      ner_test_report: '测试及报告',
    },
    material: {
      module_name: '多媒体库',
      manage: '素材管理',
    },
    manage_model: {
      module_name: '模型管理',
    },
    error: '',
  },
  statistics: {
    day: '天',
    export_mode: '高級',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn.js